import { render, staticRenderFns } from "./TypeTwo.vue?vue&type=template&id=33b42081&scoped=true"
import script from "./TypeTwo.vue?vue&type=script&lang=js"
export * from "./TypeTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b42081",
  null
  
)

export default component.exports